import React from "react";
import styled from "styled-components";


const Spacer = styled.div`
    width: 0;
    ${({fill, size}) => fill ? 'flex: 1' : `height: ${size}px`};
    ${({debug}) => debug ? 'border: 1px dashed blue;' : '' }
`;

export default ({fill=false, size=10, style, debug=false}) => (
    <Spacer fill={fill} size={size} style={style} debug={debug} />
)
